const languagesByCountry = {
  au: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  bd: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  bn: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  hk: {
    languages: ['lng_en', 'lng_zh'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    },
    {
      key: '繁體中文',
      value: 'lng_zh'
    }]
  },

  id: {
    languages: ['lng_en', 'lng_id'],
    defaultLanguage: 'lng_id',
    languagesName: [{
      key: 'Bahasa Indonesia',
      value: 'lng_id'
    },
    {
      key: 'English',
      value: 'lng_en'
    }]
  },

  jp: {
    languages: ['lng_en', 'ja-JP'],
    defaultLanguage: 'ja-JP',
    languagesName: [{
      key: '日本語',
      value: 'ja-JP'
    },
    {
      key: 'English',
      value: 'lng_en'
    }]
  },

  kr: {
    languages: ['lng_en', 'lng_ko'],
    defaultLanguage: 'lng_ko',
    languagesName: [{
      key: '한국어',
      value: 'lng_ko'
    }]
  },

  la: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  lk: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  mm: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  my: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  nz: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  ph: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  pk: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  sg: {
    languages: ['lng_en'],
    defaultLanguage: 'lng_en',
    languagesName: [{
      key: 'English',
      value: 'lng_en'
    }]
  },

  th: {
    languages: ['lng_en', 'lng_th'],
    defaultLanguage: 'lng_th',
    languagesName: [{
      key: 'ไทย',
      value: 'lng_th'
    },
    {
      key: 'English',
      value: 'lng_en'
    }]
  },

  tw: {
    languages: ['lng_en', 'zh-TW'],
    defaultLanguage: 'zh-TW',
    languagesName: [{
      key: '中文',
      value: 'zh-TW'
    },
    {
      key: 'English',
      value: 'lng_en'
    }]
  },

  vn: {
    languages: ['lng_en', 'vi-VN'],
    defaultLanguage: 'vi-VN',
    languagesName: [{
      key: 'Tiếng Việt',
      value: 'vi-VN'
    },
    {
      key: 'English',
      value: 'lng_en'
    }]
  }
}

export {
  languagesByCountry
}
